import { gql } from "@apollo/client";

export const addUserQuestionnairesFeedbacks = gql`
  mutation addUserQuestionnairesFeedbacks($record: CreateOneUserQuestionnairesFeedbacksInput!) {
    userQuestionnaireFeedback_CreateOne(record: $record) {
      record {
        _id
      }
    }
  }
`